module.exports = __webpack_public_path__ + "media/images/subject_img/GEOLOGY-EARTH SCIENCES-3ddc880dc1e50efed1c1a4c858529f2a.jpg";